module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }